<div class="bg-blue px-4 px-md-5 px-xxl-4 content-header">
  <div class="top content-section">
    <div class="d-flex al-center sp-between w-100">
      <div class="d-inline d-lg-none">
        <img src="assets/svg/menu-hamburguesa.svg" width="35" (click)="openMenu()" class="pointer" alt="">
      </div>
      <div class="d-none d-lg-block">
        <a href="https://www.instagram.com/diutinglobal/" target="_blank"><img src="assets/svg/instagram.svg" width="40" class="me-2" alt=""></a>
        <a href="https://www.facebook.com/DiutinGlobal" target="_blank" class="me-2"><img src="assets/svg/facebook.svg" width="40" alt=""></a>
        <a href="https://open.spotify.com/playlist/0HI4gB6cG2QKdKacimiLQw" target="_blank"><img src="assets/svg/spotify.svg" width="40" alt=""></a>
      </div>
      <div>
        <img src="assets/svg/logo.svg" class="pointer w-100 logo" routerLink="/" alt="">
      </div>
      <div class="toogle bg-white d-none d-lg-flex">
        <div class="option d-flex al-center sp-center pointer animated" [ngClass]="languageCurrent == 'esES' ? 'bg-blue':''" (click)="changeLanguage(0)">
          <span class="fw-bold" [ngClass]="languageCurrent == 'esES' ? 'text-white':''">{{languageOptions[0]}}</span>
        </div>
        <div class="option d-flex al-center sp-center pointer animated" [ngClass]="languageCurrent == 'esEN' ? 'bg-blue':''" (click)="changeLanguage(1)">
          <span class="bold fw-bold" [ngClass]="languageCurrent == 'esEN' ? 'text-white':''">{{languageOptions[1]}}</span>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="bg-sky d-none d-lg-block px-4 px-md-5 px-xxl-4">
  <div class="bottom content-section">
    <div class="d-flex al-center sp-between w-100">
      <div *ngFor="let nav of navHeader" [ngClass]="routerCurrent == nav.router ? 'border-b':''">
        <span class="fw-semibold fs-5 pointer" [ngClass]="routerCurrent == nav.router ? 'text-blue':'text-white'" (click)="goTo(nav.router)">{{nav.name}}</span>
      </div>
    </div>
  </div>
</div>

<nz-drawer
      [nzClosable]="false"
      [nzVisible]="visible"
      nzPlacement="left"
      nzTitle=""
      (nzOnClose)="close()"
    >
      <ng-container *nzDrawerContent>
        <div class="d-flex flex-column sp-between h-100">
          <div>
            <div class="mb-5">
              <img src="assets/svg/logo.svg" class="pointer w-100 logo" routerLink="/" alt="">
            </div>
            <div *ngFor="let nav of navHeader" class="mb-3">
              <span class="text-white fw-semibold fs-5 pointer" [routerLink]="nav.router">{{nav.name}}</span>
            </div>
          </div>
          <div>
            <div class="toogle bg-white d-flex">
              <div class="option d-flex al-center sp-center animated pointer" [ngClass]="languageCurrent == 'esES' ? 'bg-blue':''" (click)="changeLanguage(0)">
                <span class="fw-bold" [ngClass]="languageCurrent == 'esES' ? 'text-white':''">{{languageOptions[0]}}</span>
              </div>
              <div class="option d-flex al-center sp-center animated pointer" [ngClass]="languageCurrent == 'esEN' ? 'bg-blue':''" (click)="changeLanguage(1)">
                <span class="bold fw-bold" [ngClass]="languageCurrent == 'esEN' ? 'text-white':''">{{languageOptions[1]}}</span>
              </div>
            </div>
            <div class="d-flex al-center">
              <a href="https://www.instagram.com/diutinglobal/" target="_blank"><img src="assets/svg/instagram.svg" width="40" class="me-2" alt=""></a>
              <a href="https://www.facebook.com/DiutinGlobal" target="_blank" class="me-2"><img src="assets/svg/facebook.svg" width="40" alt=""></a>
              <a href="https://open.spotify.com/playlist/0HI4gB6cG2QKdKacimiLQw" target="_blank"><img src="assets/svg/spotify.svg" width="40" alt=""></a>
            </div>
          </div>
        </div>
      </ng-container>
</nz-drawer>